<template>
  <el-table-column
    prop="storage.id"
    sortable="custom"
    label="Raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.storage_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'storage.id',
};
</script>
